export enum OrderStatus {
    Draft = "draft",
    Cancelled = "cancelled",
    WaitingPayment = "waitingPayment",
    Closed = "closed",
}
